import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

interface SelectedFiltersProps {
  filters: string[];
  onRemove: (filterId: string) => void;
  isAll?: boolean;
}

const SelectedFilters = ({
  filters,
  onRemove,
  isAll = false,
}: SelectedFiltersProps) => {
  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {filters.map((filter, index) => (
        <React.Fragment key={filter}>
          <div className="px-2 py-1 bg-neutral-300 rounded-2xl inline-flex justify-center items-center gap-1 overflow-hidden">
            <div className="text-center justify-start text-primary text-xs font-medium font-['Inter'] leading-tight">
              {filter}
            </div>
            <div
              className="w-3.5 h-3.5 rounded-full bg-primary flex items-center justify-center cursor-pointer"
              onClick={() => onRemove(filter)}
            >
              <Icon icon={faTimes} size="xs" className="text-neutral-300" />
            </div>
          </div>
          {index < filters.length - 1 && (
            <span className="text-sm text-tertiary font-normal">
              {isAll ? 'and' : 'or'}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SelectedFilters;
